import styled, { css } from 'styled-components'
import { stripUnit, rem } from 'polished'

import { media } from './media'
import { greyDark, black, primaryColor, grey, greyLight } from './colors'

// Font family
export const fontFamily =
  "Gotham, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif"

// Font weights
export const fontWeights = {
  regular: 400,
  medium: 500,
  bold: 700,
  black: 800
}

export const lineHeights = {
  base: 1.5,
  heading: 1.25,
  tight: 1.1
}

// Font sizes
export const fontSizes = {
  regular: '14px',
  small: '0.9rem',
  tiny: '0.8rem',
  mini: '0.7rem'
}

export const H1 = styled.h1`
  font-weight: ${fontWeights.bold};
  color: ${greyDark};
  line-height: ${lineHeights.tight};
  font-size: 2rem;
  font-family: ${fontFamily};
  margin-bottom: 0.2em;
  ${media.small`font-size: ${rem('36px')}`};
  ${media.medium`font-size: ${rem('42px')}`};
  ${media.large`font-size: ${rem('48px')}`};
`

export const H2 = styled.h2`
  font-weight: ${fontWeights.bold};
  color: ${greyDark};
  line-height: ${lineHeights.tight};
  font-size: 1.5rem;
  font-family: ${fontFamily};
  margin-bottom: 0.25em;
  ${media.small`font-size: ${rem('27px')}`};
  ${media.medium`font-size: ${rem('31px')}`};
  ${media.large`font-size: ${rem('36px')}`};
`

export const H3 = styled.h3`
  font-weight: ${fontWeights.bold};
  color: ${greyDark};
  line-height: ${lineHeights.heading};
  font-size: 1.3rem;
  font-family: ${fontFamily};
  margin-bottom: 0.4em;
  ${media.small`font-size: 1.4rem`};
  ${media.medium`font-size: 1.5rem`};
  ${media.large`font-size: 1.6rem`};
`

export const H4 = styled.h4`
  font-weight: ${fontWeights.bold};
  color: ${greyDark};
  line-height: ${lineHeights.heading};
  font-size: 1.1rem;
  font-family: ${fontFamily};
  margin-bottom: 0.5em;
  ${media.small`font-size: 1.2rem`};
  ${media.medium`font-size: 1.25rem`};
  ${media.large`font-size: 1.3rem`};
`

export const H5 = styled.h5`
  font-weight: ${fontWeights.bold};
  font-size: 15px;
  color: ${greyDark};
  line-height: ${lineHeights.heading};
  ${media.medium`font-size: 16px`};
`

export const Lead = styled.p`
  font-size: 1.1em;

  ${media.medium`
    font-size: 1.2em;
  `};
`

export const Dark = styled.span`
  color: ${greyDark};
`

export const Muted = styled.span`
  color: ${greyLight};
`

export const Brand = styled.span`
  color: ${primaryColor};
`

export const Tiny = styled.span`
  font-size: ${fontSizes.tiny};
`

export const Lowercase = styled.span`
  text-transform: lowercase;
`

export const Capitalize = styled.span`
  text-transform: capitalize;
`

export const Uppercase = styled.span`
  text-transform: uppercase;
`

export default css`
  html {
    font-size: ${fontSizes.regular};

    ${media.medium`
      font-size: ${stripUnit(fontSizes.regular) + 1 + 'px'};
    `};

    ${media.large`
      font-size: ${stripUnit(fontSizes.regular) + 2 + 'px'};
    `};
  }

  body {
    font-family: ${fontFamily};
    font-weight: ${fontWeights.regular};
    line-height: ${lineHeights.base};
    color: ${grey};
  }

  small {
    font-size: ${fontSizes.small};
  }

  strong {
    font-weight: ${fontWeights.bold};
  }

  p {
    margin-bottom: 1.25em;

    ${media.medium`
      margin-bottom: 1.5em;
    `};

    &:last-child {
      margin-bottom: 0;
    }
  }

  p a {
    color: ${black};
    font-weight: ${fontWeights.medium};
    text-decoration: underline;
  }
`
